import { render, staticRenderFns } from "./marklostshipment.vue?vue&type=template&id=199a6be2&"
import script from "./marklostshipment.vue?vue&type=script&lang=js&"
export * from "./marklostshipment.vue?vue&type=script&lang=js&"
import style0 from "./marklostshipment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports